import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

import API, {
  GetOrganizationGroupsPathForApi,
} from '../../Util/api';
import ProgressIndicator from '../../Components/ProgressIndicator';

import { IsMobile } from '../../Util/MobileDetector';

const styles = theme => ({
});

class OrganizationGroupCreationDialog extends Component {
  constructor(props) {
    super(props);

    this.initialState = {
      ShowProgressIndicatorImmediately: false,
      Name: "",
    };

    this.state = {
      ...this.initialState,
      open: props.open,
    }
  }

  setInitialState = () => {
    this.setState(this.initialState);
  }

  handleClose = () => {
    this.setState({
      open: false,
    });
    this.setInitialState();
    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleCreate = () => {
    if (!this.state.Name) {
      return;
    }

    this.setState({ShowProgressIndicatorImmediately: true});

    const newGroup = { Name: this.state.Name };
    if (this.props.onBeginCreate) {
      this.props.onBeginCreate(newGroup);
    }

    API.post(GetOrganizationGroupsPathForApi(this.props.organizationId), newGroup)
      .then(resp => {
        if (this.props.onCreated) {
          this.props.onCreated(resp.data);
        }
        this.setInitialState();
      })
      .catch(this.handleApiError);
  }

  handleApiError = (err, title_optional) => {
    this.setState({
      ShowProgressIndicatorImmediately: false,
    });
    this.props.onApiError(err, title_optional);
    if (err) {
      setTimeout(() => this.props.onApiError(null), 1);
    }
  }

  componentDidUpdate(prevProps) {
    if (typeof this.props.open !== "undefined"
      && prevProps.open !== this.props.open) {
      this.setState({open: this.props.open !== false});
    }
  }

  render() {
    const {
      open,
      Name,
      ShowProgressIndicatorImmediately,
  	} = this.state;
    const {
      theme,
      organizationName,
    } = this.props;

    let progressIndicator = null;
    if (ShowProgressIndicatorImmediately) {
      progressIndicator = (
        <ProgressIndicator showImmediately={ShowProgressIndicatorImmediately} />
      );
    }

    let dialogActions = (
      <DialogActions>
        <Button onClick={() => this.handleClose()}>
          CLOSE
        </Button>
        <Button onClick={() => this.handleCreate()}>
          CREATE
        </Button>
      </DialogActions>
    );

    let content = (
      <div style={{marginTop:theme.spacing(1)}}>
        <TextField
          fullWidth
          autoFocus
          variant="outlined"
          label="Name"
          onChange={e => this.setState({Name: e.target.value})}
          value={Name}
          onKeyDown={e => { if (e.keyCode === 13) { this.handleCreate(); } }}
        />
      </div>
    );

    const dialogTitle = `Create an organization group${(organizationName) ? " in " + organizationName : ""}`;

    return (
       <Dialog
        fullWidth={!IsMobile()}
        fullScreen={IsMobile()}
        maxWidth="sm"
        open={open}
        onClose={() => this.handleClose()}
        aria-labelledby="dialog-title"
        aria-describedby="dialog-description">
        <DialogTitle id="dialog-title">
          {dialogTitle}
        </DialogTitle>
        <DialogContent style={{paddingTop:0}}>
          {progressIndicator}

          {content}
        </DialogContent>

        {dialogActions}
      </Dialog>
    );
  }
}

OrganizationGroupCreationDialog.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool,
  organizationId: PropTypes.string.isRequired,
  organizationName: PropTypes.string,
  onBeginCreate: PropTypes.func,
  onCreated: PropTypes.func,
  onApiError: PropTypes.func.isRequired,
  onClose: PropTypes.func,
};

export default withStyles(styles, {withTheme: true})(OrganizationGroupCreationDialog);
